module.exports = __webpack_public_path__ + "r-v3/img/icon-schedule-quiz_white.381fc8bc.svg";